import { mountApplication } from '@salsita-ai/platform-project-sdk/application'

import { config } from './config'

mountApplication(config)
